export default __webpack_public_path__ + "static/assets/med_gel_solid_01_f.223df216.png";